<div class="progress" [class.completed]="progress===100">
  <div class="center">
    <img src="../assets/images/B.svg" alt="loader">
    <span [ngStyle]="getProgressStyle()"></span>
  </div>
  <span *ngIf="progress===100" class="text">COMPLETED</span>
  <span *ngIf="progress<100" class="text">{{progress}}&nbsp;%</span>
</div>
